export default class PublicProperties {
  constructor(
    description,
    telegramChanel,
    telegramId,
    instagramId,
    facebook,
    googlePlus,
    linkedIn,
    aparat,
    website,
    email,
    phoneNumber,
    workingContext
  ) {
    this.description = description;
    this.telegramChanel = telegramChanel;
    this.telegramId = telegramId;
    this.instagramId = instagramId;
    this.facebook = facebook;
    this.googlePlus = googlePlus;
    this.linkedIn = linkedIn;
    this.aparat = aparat;
    this.website = website;
    this.email = email;
    this.phoneNumber = phoneNumber;
    this.workingContext = workingContext;
  }
}
